const SquareThailand = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 16">
      <g clipPath="url(#a)">
        <g clipPath="url(#b)">
          <rect width="22" height="16" fill="white" rx="2" />
          <path fill="#F93939" fillRule="evenodd" d="M0 0H22V3.2H0V0ZM0 12.8H22V16H0V12.8Z" clipRule="evenodd" />
          <path fill="#232C80" fillRule="evenodd" d="M0 5.3335H22V10.6668H0V5.3335Z" clipRule="evenodd" />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="white" d="M0 0H22V16H0z" />
        </clipPath>
        <clipPath id="b">
          <rect width="22" height="16" fill="white" rx="2" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SquareThailand;
